import PropTypes from 'prop-types';
import React from 'react';
import {Col} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {FooterRow, TitleButton} from '../../../common/components/StyledComp';

const ProfileFooter = ({t, loading, onClick}) => {
  return (
    <FooterRow>
      <Col sm={{span: 6, offset: 3}} className="gradient-button">
        <TitleButton disabled={loading} onClick={onClick}>
          {t('addUser.save')}
        </TitleButton>
      </Col>
    </FooterRow>
  );
};

ProfileFooter.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default withTranslation('user')(ProfileFooter);
